export default "__VITE_ASSET__DDkv420J__"